import { Injectable } from '@angular/core';

import {
  CollectionConfig,
  CollectionService,
} from 'akita-ng-fire';

import { RouterQuery } from '@datorama/akita-ng-router-store';

import { Contact } from './contact.model';
import {
  ContactsState,
  ContactsStore,
} from './contacts.store';

@Injectable({ providedIn: 'root' })
@CollectionConfig({ path: 'contacts' })
export class ContactsService extends CollectionService<ContactsState> {
  constructor(store: ContactsStore, private routerQuery: RouterQuery) {
    super(store);
  }

  get path() {
    const companyId = this.routerQuery.getParams()?.companyId;
    return `companies/${companyId}/contacts`;
  }

  formatToFirestore(model: Contact) {
    return {
      ...model,
      ...this.routerQuery.getParams(),
    };
  }
}
